import { render } from "./Basket.vue?vue&type=template&id=0dc172df&scoped=true"
import script from "./Basket.vue?vue&type=script&lang=js"
export * from "./Basket.vue?vue&type=script&lang=js"

import "./Basket.vue?vue&type=style&index=0&id=0dc172df&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4280824369/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dc172df"]])

export default __exports__